import { lazy, LazyExoticComponent, ComponentType } from 'react';
import type { CheckoutOut, ShopOut } from 'openapi-client';
import {
	normalizePaymentMethodUpdateModel,
	type PaymentMethodUpdateModel,
} from './payment-method-update/types';

export interface PageModels {
	shop: ShopOut;
	checkout: CheckoutOut;
	'payment-method-update': PaymentMethodUpdateModel;
}

export interface PageRegistryEntry<T> {
	component: LazyExoticComponent<ComponentType<{ model: T }>>;
	getModel: (initialData: T) => T;
}

export const pageRegistry: {
	[K in keyof PageModels]: PageRegistryEntry<PageModels[K]>;
} = {
	shop: {
		component: lazy(() => import('./shop/shop')),
		getModel: (initialData) => initialData,
	},
	checkout: {
		component: lazy(() => import('./checkout/checkout')),
		getModel: (initialData) => initialData,
	},
	'payment-method-update': {
		component: lazy(() => import('./payment-method-update/payment-method-update')),
		getModel: normalizePaymentMethodUpdateModel,
	},
};
